export const SET_MANDAYS_DATA = "SET_MANDAYS_DATA";

const initialState = {
  mandaysList: [],
};

export default (state = initialState, action = {}) =>
  action.type === SET_MANDAYS_DATA ? { ...state, ...action.payload } : state;
